import React, { Fragment } from 'react';
import DaywiseSalesTrendReportView from './DaywiseSalesTrendReportView';

// Thin route entry — the V3 shell lives inside the view.
const DaywiseSalesTrendReport = () => (
    <Fragment>
        <DaywiseSalesTrendReportView />
    </Fragment>
);

export default DaywiseSalesTrendReport;
